// helper function to sort aliases so that protected aliases are first
// and both protected and normal aliases are ordered alphabetically
export function sortAliases(
  alias1: {name: string; isProtectedAlias: boolean},
  alias2: {name: string; isProtectedAlias: boolean}
) {
  if (alias1.isProtectedAlias === alias2.isProtectedAlias) {
    return alias1.name.localeCompare(alias2.name);
  }
  return alias1.isProtectedAlias ? -1 : 1;
}
